import { createContext } from 'react'

const GuestLoginDialogContext = createContext({})

export default GuestLoginDialogContext
